// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.c-input-floating-label {\n  min-width: 50px;\n}\n.c-input-floating-label .c-input-label-fullname {\n  top: 8px!important;\n}\n.new-position-form__workload .c-input-wrapper {\n  overflow: visible!important;\n}\n.new-position-form .c-input-floating-label {\n  padding-right: 23px!important;\n}\n", ""]);
// Exports
module.exports = exports;
